import React from 'react';
import {Footer, StandardSection, HeaderSection} from "./Layouts";
import resume1 from './media/Resume1.jpg'
import resume2 from './media/Resume2.jpg'
import resumeFile from './media/Resume.pdf';
import './About.scss';

class Resume extends React.Component{
    render() {
        return(
            <div className='page'>
                <HeaderSection title="Resume" color="retro-yellow" />
                <StandardSection color ="retro-green">
                    <div className="section">
                        <img src={resume1} className="resume-img" />
                        <img src={resume2} className="resume-img" />
                        <p><a href={resumeFile} className="button" download>Download</a></p>
                    </div>
                </StandardSection>
                <Footer />
            </div>
        )
    }
}

export default Resume;